import { onMounted, ref } from "vue"
import { fetchArticles } from '@/api'

const articles = ref([])
export function useArticles() {
  function getArticles() {
    onMounted(async () => {
      articles.value = await fetchArticles()
    })
  }

  return {
    articles,
    fetchArticles: getArticles
  }
}